import React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFormFieldLayout } from 'components/FormField';
import { FileNameField, FileSizeField, LastUpdatedField } from 'components/FormFields';
import FormStack from 'components/FormStack';
import { TitleCardWithToggle } from 'components/TitleCard';
import Button from 'components/Button';
import ProcessingAlert from './ProcessingAlert';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FileDetailsCard(_ref) {
  var _ref$isProcessingErro = _ref.isProcessingError,
    isProcessingError = _ref$isProcessingErro === void 0 ? false : _ref$isProcessingErro,
    _ref$showUploadProgre = _ref.showUploadProgress,
    showUploadProgress = _ref$showUploadProgre === void 0 ? false : _ref$showUploadProgre,
    _ref$isNewFile = _ref.isNewFile,
    isNewFile = _ref$isNewFile === void 0 ? false : _ref$isNewFile,
    isEditMode = _ref.isEditMode,
    isDistributed = _ref.isDistributed,
    uploadProgress = _ref.uploadProgress,
    content = _ref.content,
    onReplace = _ref.onReplace,
    onDelete = _ref.onDelete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(TitleCardWithToggle, {
    variant: "raised",
    title: t('content_type_file_details'),
    sideContent: /*#__PURE__*/_jsx(Button, {
      icon: "cycle",
      size: "medium",
      onClick: onReplace,
      isDisabled: isDistributed,
      children: t('actions_replace_file')
    }),
    children: /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
      horizontal: true,
      children: /*#__PURE__*/_jsxs(FormStack, {
        spacing: "m",
        children: [isProcessingError && /*#__PURE__*/_jsx(ProcessingAlert, {
          isEditMode: isEditMode,
          fileName: content === null || content === void 0 ? void 0 : content.fileName,
          onReplace: onReplace,
          onDelete: onDelete
        }), /*#__PURE__*/_jsx(FileNameField, {
          bold: false,
          isEditMode: isEditMode,
          isNewFile: isNewFile,
          assetId: content === null || content === void 0 ? void 0 : content.id,
          fileName: content === null || content === void 0 ? void 0 : content.fileName
        }), /*#__PURE__*/_jsx(FileSizeField, {
          bold: false,
          showUploadProgress: showUploadProgress,
          size: content === null || content === void 0 ? void 0 : content.size,
          uploadProgress: uploadProgress
        }), /*#__PURE__*/_jsx(LastUpdatedField, {
          bold: false,
          lastUpdated: content === null || content === void 0 ? void 0 : content.fileUploadedTime
        })]
      })
    })
  });
}
export default FileDetailsCard;